// engine
import { ExtendedContainer, ExtendedText, gsap, platform, SkySpine, soundService } from "@aceroll/core";
import { FEATURE_TYPES } from "../../constants";

const SOUNDS = {
    SHOW: 'feature_popup_show',
    HIDE: 'feature_popup_hide'
}

const ANIMATIONS = {
    SHOW: "close",
    IDLE: "idle",
    HIDE: "open"
}

const TEXTS_CONFIG = [
    {
        name: "Header",
        id: "bonus_10_freespins",
        style: "bonusHeaderText",
        position: { x: 0, y: -276 },
    },
    {
        name: "Click",
        id: "click_to_continue_uc",
        style: "bonusClickableText",
        position: { x: 0, y: 208 },
    },
]

const TEXTS_BONUS_1 = [
    {
        name: "Bonus_1_title",
        id: "bonus_echo_passage_uc",
        style: "bonusBodyText",
        position: { x: 0, y: -115 },
    },
    {
        name: "Bonus_1_description",
        id: "bonus_echo_passage_desc",
        style: "bonusBodyText",
        position: { x: 0, y: 35 },
    }
]

const TEXTS_BONUS_2 = [
    {
        name: "Bonus_2_title",
        id: "bonus_temporal_duat_uc",
        style: "bonusBodyText",
        position: { x: 0, y: -90 },
    },
    {
        name: "Bonus_2_description",
        id: "bonus_temporal_duat_desc",
        style: "bonusBodyText",
        position: { x: 0, y: 35 },
    }
]

export default class FeaturePopup extends ExtendedContainer {
    constructor() {
        super('feature-popup');

        this.spine = new SkySpine('spine-bonus_intro_popup');
        this.spine.visible = false;
        this.visible = false;
        this.featureName = '';

        this.#setPopupHandler();
        this.#createTexts();
    }

    async show(amount, featureName) {
        this.featureName = featureName;
        this.visible = true;
        soundService.play(SOUNDS.SHOW);

        this.spine.visible = true;

        await this.spine.setImmediately(ANIMATIONS.SHOW);
        this.#showTexts(this._textsContainer)
        if (this.featureName === FEATURE_TYPES.BONUS_1) {
            this.#showTexts(this._bonus1TextsContainer)
        } else {
            this.#showTexts(this._bonus2TextsContainer)
        }
        this.playIdle();
    }

    async hide() {
        if (!this.visible) {
            return;
        }

        if (this.featureName === FEATURE_TYPES.BONUS_1) {
            this.#hideTexts(this._bonus1TextsContainer)
        } else {
            this.#hideTexts(this._bonus2TextsContainer)
        }
        await this.#hideTexts(this._textsContainer);

        this.spine.reset();
        soundService.play(SOUNDS.HIDE);
        await this.spine.setImmediately(ANIMATIONS.HIDE);
        this.visible = false;
        this.spine.visible = false;
    }

    playIdle() {
        this.spine.addAnimation(ANIMATIONS.IDLE, true);
    }

    #setPopupHandler() {
        platform.onceClickScreen().then(() => {
            this.hide();
        });
    }

    #createTexts() {
        this._textsContainer = this.addChild(new ExtendedContainer('TextsContainer'));
        this._textsContainer.visible = false;
        this._textsContainer.alpha = 0;
        this._bonus1TextsContainer = this.addChild(new ExtendedContainer('Bonus1TextsContainer'));
        this._bonus1TextsContainer.visible = false;
        this._bonus1TextsContainer.alpha = 0;
        this._bonus2TextsContainer = this.addChild(new ExtendedContainer('Bonus2TextsContainer'));
        this._bonus2TextsContainer.visible = false;
        this._bonus2TextsContainer.alpha = 0;

        TEXTS_CONFIG.forEach(config => {
            this._textsContainer.addChild(this.#createTextLabel(config));
        });
        TEXTS_BONUS_1.forEach(config => {
            this._bonus1TextsContainer.addChild(this.#createTextLabel(config));
        });
        TEXTS_BONUS_2.forEach(config => {
            this._bonus2TextsContainer.addChild(this.#createTextLabel(config));
        });
    }

    #createTextLabel(config) {
        const { name, id, style, position } = config;
        const text = new ExtendedText(name, id, style);

        text.name = name;
        text.position.set(position.x, position.y);
        text.anchor.set(0.5);

        return text;
    }

    async #showTexts(container, duration = 1) {
        return new Promise(resolve => {
            container.visible = true;
            gsap.fromTo(container,
                { alpha: 0 },
                { alpha: 1, duration, onComplete: () => resolve() }
            );
        });
    }

    async #hideTexts(container, duration = 0.5) {
        return new Promise(resolve => {
            gsap.fromTo(container,
                { alpha: 1 },
                {
                    alpha: 0, duration, onComplete: () => {
                        container.visible = false;
                        resolve();
                    }
                }
            );
        });
    }
}